/**
 * Utility functions for formatting status names
 */

/**
 * Device status options - single source of truth for all device status dropdowns and filters
 * Order matches the filter buttons on the Devices page
 */
export const DEVICE_STATUS_OPTIONS = [
  { value: 'draft', label: 'Draft' },
  { value: 'print_label', label: 'Print label' },
  { value: 'active', label: 'Active' },
  { value: 'demo', label: 'Demo' },
  { value: 'sponsored', label: 'Sponsored' },
  { value: 'blocked', label: 'Blocked' },
  { value: 'lost', label: 'Lost' },
  { value: 'retired', label: 'Retired' },
  { value: 'donated', label: 'Donated' },
  { value: 'wasted', label: 'Trashed' }
];

/**
 * Device statuses that must not enter the repair procedure
 */
export const NON_REPAIRABLE_DEVICE_STATUSES = ['retired', 'lost', 'blocked', 'wasted'];

/**
 * Device statuses that are out of circulation. Search results still surface these
 * devices, but flag their status so it is obvious why they are not in the normal list.
 */
export const INACTIVE_DEVICE_STATUSES = ['retired', 'donated', 'wasted'];

/**
 * Format device status ID to display name (e.g. 'wasted' -> 'Trashed')
 */
export const formatDeviceStatus = (status) => {
  const option = DEVICE_STATUS_OPTIONS.find(o => o.value === status);
  return option ? option.label : status;
};

/**
 * Format repair status ID to display name
 * @param {string} status - The status ID (e.g., 'ready_for_shipping')
 * @returns {string} - The formatted display name (e.g., 'Ready for shipping')
 */
export const formatRepairStatus = (status) => {
  const statusMap = {
    draft: 'Draft',
    backlog: 'Backlog',
    waiting_for_repair: 'Waiting for repair',
    clarification_required: 'Clarification required',
    waiting_for_clarification: 'Clarification required', // Legacy alias
    waiting_for_dev_input: 'Waiting for dev input',
    waiting_for_customer_response: 'Waiting for customer response',
    work_in_progress: 'Work in progress',
    repaired: 'Repaired',
    ready_for_shipping: 'Ready for shipping',
    waiting_for_payment: 'Waiting for payment',
    completed: 'Completed',
    // Legacy statuses for backward compatibility
    in_progress: 'Work in progress',
    cancelled: 'Cancelled',
    received: 'Received',
    clarification: 'Waiting for clarification',
    waiting_repair: 'Waiting for repair',
    waiting_payment: 'Waiting for payment',
    waiting_spare_parts: 'Backlog',
    ready4shipment: 'Ready for shipping',
    pending: 'Backlog',
    wip: 'Work in progress',
    done: 'Completed'
  };

  return statusMap[status] || status;
};











